module.exports = __webpack_public_path__ + "static/media/shareridge.70b40c29.png";